import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "../lib/firebase";
import EmployeesController from "./EmployeeController";
import { useAuthState } from "react-firebase-hooks/auth";
import { useRole } from "../lib/userRole";

function Employees() {
  const { auth, api } = useContext(FirebaseContext);
  const { getUserRole } = api;
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const { setRole } = useRole();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    const getRole = async () => {
      const userRole = await getUserRole(user?.uid);
      setRole(userRole);
    };
    if (user) {
      getRole();
    }
  }, [user, loading, navigate, setRole, getUserRole]);

  return <EmployeesController />;
}

export default Employees;
